import {
  Mark
} from 'tiptap';
import {
  setBlockType,
  updateMark,
  removeMark,
  toggleMark,
  markInputRule,
  markPasteRule
} from 'tiptap-commands';



export default class TextWithId extends Mark {

  get name() {
    return 'textWithId'
  }

  get defaultOptions() {
    return {
      openOnClick: true,
    }
  }

  get schema() {
    return {
      attrs: {
        id: {
          default: null,
        },
        element_tag: {
          default: "span"
        }
      },
      inclusive: false,
      parseDOM: [{
        tag: '*[id]',
        getAttrs: mark => {
          console.log(mark);
          return {
            'id': mark.getAttribute('id'),
            'element_tag': mark.tagName.toLowerCase(),
          }
        }
      }, ],
      toDOM: node => [node.attrs.element_tag, {
        id: node.attrs.id,
        element_tag: node.attrs.element_tag,
      }, 0],
    }
  }

  commands({
    type
  }) {
    return attrs => {
      // setBlockType(type);
      if (attrs.id) {
        return updateMark(type, attrs);
      }

      return removeMark(type);
    }
  }
  inputRules({
    type
  }) {
    return [
      markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type),
    ]
  }

  pasteRules({
    type
  }) {
    return [
      markPasteRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)/g, type),
    ]
  }

}
